import p from '../../theme/palette';

const theme = {
  sidebar: {
    backgroundColor: p.sidebarBg,
  },
  sidebarContent: {
    backgroundColor: p.sidebarBg,
  },
  sidebarContentForLoggedOut: {
    padding: 20,
  },
  sidebarHeader: {
    backgroundColor: p.sidebarBg,
  },
  sidebarLink: {
    color: p.sidebarText,
  },
  sidebarActiveLink: {
    color: p.sidebarTextActive,
    fontWeight: 600,
  },
};

export default theme;
